import React, {Component} from 'react';
import OwlCarousel from 'react-owl-carousel';
import {getFavouriteGames, getGames, setFavouriteGames} from "../../actions/GamesActions";
import {connect} from "react-redux";
import {getCategories} from "../../actions/CategoryActions";
import {hide, show} from "../../actions/ActivityIndicatorActions";
import { appendUid } from '../../utils/helper';
import { FormattedMessage } from 'react-intl';
import { isGamiclub } from '../../constants/isGamiclub';
import { isGameflares, isGamiway } from '../../constants/productCondition';
import { config } from '../../constants/domainConfig';


class CategoryList extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     return false;
    // }

    render(){
        const {gametype}=this.props;
        let currentLanguage=this.props.access.currentLang;
        let categories;
        let loopvalue = false;
        if(window.location.hash.indexOf('html') >=0){
            categories =  this.props.categories.categories.filter((item) => {
                //console.log(item);
                if(item.categoryTypeName == 'HTML5'){
                    if (item.categoryName == "New Arrivals") {
                        item.categoryImage = "https://cdn.game-lords.com/new+games/new-arrivals.png";
                    }
                    else if (item.categoryName == "Action") {
                        item.categoryImage = "https://cdn.game-lords.com/new+games/action.png";
                    }
                    else if (item.categoryName == "Adventure") {
                        item.categoryImage = "https://cdn.game-lords.com/new+games/adventure.png";
                    }
                    else if (item.categoryName == "Arcade") {
                        item.categoryImage = "https://cdn.game-lords.com/new+games/arcade.png";
                    }
                    return item;
                }
        });
        }
        else if(window.location.hash.indexOf('video') >=0){
            categories =  this.props.categories.categories.filter((item) => {
            if(item.categoryTypeName == 'VIDEO'){
                return item;
            }
    });
    }
            else {
            categories = this.props.categories.categories.filter((item) => {
                if (item.categoryTypeName == 'ANDROID') {
                    if (isGamiclub && config.subDomain === 'fr' && item.categoryId === 4) {
                        item.categoryName = "Action (18+)";
                    }
                    return item;
                }
            });
        }
        if(categories.length > 3 ){
            loopvalue = true;
        }
        if(categories && categories.length > 0){
            return(
                <OwlCarousel loop={loopvalue} margin={30} items={50} dots={false} nav={false} center={false} autoWidth={true}>
                    {categories.map((c, k) => {
                            return (
                                (c.categoryTypeName.toLowerCase() == gametype) ?
                            (
                                    <div key={k} className="item">
                                        <div className={isGamiclub ? "category-box-gamiclub" :isGameflares ? "category-box gameflares-category-box" : isGamiway ? "category-box gamiway-category-box": "category-box" }>
                                            <img src={c.categoryImage} alt={c.categoryNameTranslated}/>
                                            <div className={isGamiclub ? "category-box-inner-gamiclub" : isGameflares ? "category-box-inner gameflares-category-box-inner" : isGamiway ? "category-box-inner gamiway-category-box-inner": "category-box-inner" }></div>
                                            <a className="category-box-btn" href={'/#/category/' + c.categoryId+ "?uid=" + this.props.access.uid}>
                                            <span className="category-box-type text-uppercase">
                                                <FormattedMessage id={`${c.categoryName}`}
                                                    defaultMessage={c.categoryName}
                                                />
                                            </span></a>
                                        </div>
                                    </div>
                            )
                            :
                            null
                            )
                        })
                    }
                </OwlCarousel>
            )
        }
        else return null;
    }
}

const mapStateToProps = (state) => {
    return {
        domains: state.DomainReducer,
        country: state.CountryReducer,
        categories: state.CategoryReducer,
        games: state.GamesReducer,
        access: state.WelcomeReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getGames,
        getCategories,
        getFavouriteGames,
        setFavouriteGames,
        show,
        hide
    }, dispatch);
};

export default connect(mapStateToProps)(CategoryList);


// WEBPACK FOOTER //
// ./src/components/CategoryList/CategoryList.js